import { useState, Fragment } from 'react'
import React from "react";

import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'

const languages = [
  { id: 1, name: 'English' },
  { id: 2, name: 'Portuguese' },
]

const SelectLanguage = () => {
  const [selected, setSelected] = useState(languages[0])

  return (
    <Listbox value={selected} onChange={setSelected}>
      <div className="relative mt-1 max-w-xs mx-auto md:mx-0">
        <Listbox.Button className="relative w-full cursor-pointer rounded-xl bg-white/5 border border-white/15 backdrop-blur-xl py-2.5 pl-4 pr-10 text-left text-white/80 font-poppins text-sm hover:border-white/30 focus:outline-none focus:border-reored transition-colors duration-200">
          <span className="block truncate">{selected.name}</span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <ChevronUpDownIcon
              className="h-5 w-5 text-white/40"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute bottom-full mb-2 max-h-60 w-full overflow-auto rounded-xl bg-voidcard border border-white/10 py-1 text-sm shadow-2xl backdrop-blur-xl focus:outline-none z-20">
            {languages.map((language, languageIdx) => (
              <Listbox.Option
                key={languageIdx}
                className={({ active }) =>
                  `relative cursor-pointer select-none py-2.5 pl-10 pr-4 font-poppins transition-colors duration-150 ${
                    active ? 'bg-white/10 text-white' : 'text-white/60'
                  }`
                }
                value={language}
              >
                {({ selected }) => (
                  <>
                    <span
                      className={`block truncate ${
                        selected ? 'font-medium text-white' : 'font-normal'
                      }`}
                    >
                      {language.name}
                    </span>
                    {selected ? (
                      <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-reored">
                        <CheckIcon className="h-4 w-4" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  )
}

export default SelectLanguage
